<form id="zoneDamageEditForm" [formGroup]="zoneDamageEditForm" autocomplete="off">
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label class="control-label required">{{'i18n.domain.zone-damage.fields.zone' | translate}}</label>
      <ejs-dropdownlist id="zone"
                        [dataSource]="zoneList"
                        [fields]="dropdownSettings"
                        [showClearButton]="true"
                        formControlName="zone">
      </ejs-dropdownlist>
      <app-error-messages [control]="zoneDamageEditForm.controls.zone"></app-error-messages>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label required">{{'i18n.domain.zone-damage.fields.device' | translate}}</label>
      <ejs-dropdownlist id="deviceId"
                        [dataSource]="deviceList"
                        [fields]="dropdownSettings"
                        [showClearButton]="true"
                        formControlName="deviceId">
      </ejs-dropdownlist>
      <app-error-messages [control]="zoneDamageEditForm.controls.deviceId"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label class="control-label required">{{'i18n.domain.zone-damage.fields.status' | translate}}</label>
      <ejs-dropdownlist id="state"
                        formControlName="state"
                        [fields]="enumDropdownSettings"
                        [showClearButton]="true"
                        [dataSource]="states">
      </ejs-dropdownlist>
      <app-error-messages [control]="zoneDamageEditForm.controls.state"></app-error-messages>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label required">{{'i18n.domain.zone-damage.fields.position' | translate}}</label>
      <app-map-box-map [(mapData)]="mapData"></app-map-box-map>
      <app-error-messages [control]="zoneDamageEditForm.controls.position"></app-error-messages>
    </div>
  </div>
  @if (damage && damage.reporter) {
    <div class="form-row row">
      <div class="form-group col-md-6">
        <label for="reporter" class="control-label">{{'i18n.domain.zone-damage.fields.reporter' | translate}}</label>
        <input id="reporter" name="reporter" type="text" autocomplete="off" class="form-control" formControlName="reporter" />
      </div>
      <div class="form-group col-md-6">
        <label for="phoneNumber" class="control-label">{{'i18n.shared.fields.phone' | translate}}</label>
        <input id="phoneNumber" name="phoneNumber" type="text" autocomplete="off" class="form-control" formControlName="phoneNumber" />
      </div>
    </div>
  }
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label for="reportTime" class="control-label">{{'i18n.domain.zone-damage.fields.reportTime' | translate}}</label>
      <input id="reportTime" name="reportTime" type="text" autocomplete="off" class="form-control" formControlName="reportTime" />
    </div>
  </div>

  <div class="form-row row mt-2">
    <div class="form-group col-md-12">
      <label for="damageDescription" class="control-label">{{'i18n.domain.zone-damage.fields.damageDescription' | translate}}</label>
      <textarea id="damageDescription" name="damageDescription" autocomplete="off" class="form-control" formControlName="damageDescription"></textarea>
    </div>
  </div>

  @if (damage.mediaFiles && damage.mediaFiles.length) {
    <div class="d-flex align-items-center flex-wrap">
      @for (imageId of damage.mediaFiles; track imageId) {
        <app-async-image [request]="getImageRequest(damage.id, imageId)"></app-async-image>
      }
    </div>
  }
</form>
